export default {
  general: {
    search: 'Search',
    edit: 'Edit',
    confirm: 'Confirm',
    remove: 'Remove',
    cancel: 'Cancel',
    save: 'Save',
    finish: 'Finish',
    name: 'Name',
    add: 'Add',
    ok: 'OK',
    details: 'Details',
    packOs: 'PackOS',
    config: 'ConfigHub',
    workboost: 'WorkBoost',
    keepup: 'KeepUp',
    goodin: 'GoodIn',
    goodinQa: 'GoodIn QA',
    bucketService: 'Bucket Service',
    knowlake: 'KnowLake',
    logicprint5: 'LogicPrint5',
    logicprint7: 'LogicPrint7',
    results: 'results',
    noPermissions: 'No permissions',
    plant: 'Plant',
    description: 'Description',
    code: 'Code',
    to: 'To',
    from: 'From',
    copiedToClipboard: 'Copied to clipboard',
    now: 'Now',
    noData: 'No data',
    default: 'Default',
    clone: 'Clone',
    general: 'General',
    iWantToProceed: 'I want to proceed',
    requestReceived: 'Request received',
    of: 'of',
  },
  menu: {
    userSettings: 'Account settings',
    logout: 'Logout',
  },
  plants: {
    name: 'Name',
    code: 'Code',
    latitude: 'Latitude',
    longitude: 'Longitude',
    structure: 'Plant structure',
    selectPlant: 'Select plant',
  },
  diy: {
    setupStatuses: 'Plant configuration status',
    database: 'Database',
    appService: 'App service',
    deployment: 'Deployment',
    apiPlantsInfoUpdate: 'Adding information about a new plant to the API',
    enforceSetupDoneStatus: 'Enforce done status',
    setupErrorMessage: 'Configuration has failed. Please contact support.',
  },
  elements: {
    area: 'Area',
    line: 'Line',
    machine: 'Machine',
    type: 'Element type',
    location: 'Location',
    addElement: 'Add line/machine/area',
    capabilities: 'Capabilities',
    capability: {
      activities: 'Activities',
      downtimes: 'Downtimes',
      production: 'Production',
      oee: 'OEE',
    },
  },
  auth: {
    signOut: 'Sign out',
  },
  pages: {
    plants: 'Plants',
    people: 'People',
    classifications: 'Classifications',
    products: 'Products',
    settings: 'Settings',
    licenses: 'Licenses',
    myAccount: 'My account',
    auditLog: 'Audit log',
  },
  people: {
    users: 'Users',
    roles: 'Roles',
    competences: 'Competences',
    noPermission: 'No user management permission',
  },
  users: {
    add: 'Add user',
    all: 'All users',
    import: 'Import users',
    userName: 'Login',
    firstName: 'First name',
    lastName: 'Last name',
    name: 'User name',
    displayName: 'Name',
    email: 'E-mail',
    phone: 'Phone',
    companyEmployeeId: 'Company employee ID',
    new: 'New user',
    roles: 'Roles',
    elementAccess: 'Access to',
  },
  settings: {
    card: 'Card',
    blockCard: 'Block card',
    pinChange: 'Change PIN',
    cardPin: 'Card PIN',
    oldCardPin: 'Current card PIN',
    newCardPin: 'New card PIN',
    cardId: 'Card id',
    activeSince: 'Active since',
    inactiveSince: 'Inactive since',
    pinLengthError: 'PIN must have exactly 4 numbers',
    cardIdLengthError: 'Card ID is too short. Minimum length:',
    help: 'Help',
  },
  account: {
    password: 'Password',
    roles: 'Roles',
    passwordsNotEqual: 'Both passwords must be the same',
    repeatPassword: 'Repeat Password',
    newPassword: 'New password',
    oldPassword: 'Current password',
    claims: 'Permissions',
    edit: 'Account edit',
    usersEdition: 'Users edition',
    selfEditWarning: 'You can\'t edit your own permissions to plants',
    settings: 'My account',
    permissions: 'Permissions',
  },
  error: {
    unknown: 'Unknown error',
    incorrectEmail: 'The e-mail address should be in the following format: example@domain.com',
    emptyInput: 'That field cannot be empty!',
    wrongInput: 'Given data is invalid!',
    passwordsMustBeEqual: 'Passwords must be equal!',
    incorrectCoordinate: 'The coordinate value should be in the following format: 12.34567',
    incorrectCode: 'The code can only contain letters and digits and cannot be longer than 256 characters',
    importNotAvailable: 'Import is not currently available. Please try again later',
    jobFailed: 'There was an error in processing the file',
    listOfErrors: 'List of errors',
    tooLongString: 'The field value is too long',
    userNameTooLong: 'The login is too long (max 450)',
  },
  competence: {
    add: 'Add competence',
    expiryDate: 'Expiry date',
  },
  role: {
    add: 'Add role',
    manager: 'Manager',
    new: 'New role',
    chooseRole: 'Choose role',
  },
  permissions: {
    inheritedFrom: 'Inherited from ',
    add: 'Add permissions',
    systemAdmin: 'System administrator',
    releaseNotesAccess: 'Release notes',
    choosePermission: 'Choose permission',
    chooseTenant: 'Choose Tenant',
    chooseGroup: 'Choose Group',
    choosePlant: 'Choose plant',
    chooseAsset: 'Choose asset',
    assignedTargets: 'Assigned',
    unassign: 'Unassign',
    configure: 'Configure',
    tenantAdminAccess: 'Tenant administrator',
    tenantLicenseAccess: 'License summary',
    plantElementAccess: 'Plant element access',
    worklogRerun: 'Rerun/replay line data processing',
    plantAccess: 'Plant access',
    changeDowntimes: 'Changing downtimes',
    elementAccess: 'Element access',
    projectCreateAccess: 'Project create access',
    usersManagementAccess: 'Users management access',
    projectAdminAccess: 'Project administrator',
    projectAccess: 'Project access',
    taskAdminAccess: 'Task administrator',
    taskStatusAccess: 'Task status change access',
    orderManagementAccess: 'Production order management access',
    orderOperationAccess: 'Production order operation access',
    plantAdminAccess: 'Plant administrator',
    writeAccess: 'Access to modify element and its orders',
    readAccess: 'Access to browse element and its orders',
    orderManagement: 'Order management',
    orderCreate: 'Create orders',
    orderViewAccess: 'View orders',
    orderCompleteManualProduction: 'Complete order manual production access',
    orderCompleteEdit: 'Complete order edit access',
    orderInprogressEdit: 'Inprogress order edit access',
    orderLifecycle: 'Order lifecycle management',
    orderEdit: 'Order edit',
    orderWithdraw: 'Withdraw released/activated order',
    materialManagement: 'Master Material management',
    showSkuList: 'Show SKU list',
    editSkuList: 'Manage SKU',
    statesManagement: 'Edit machine states and rules',
    statesEdit: 'States edit',
    addReason: 'Adding reason',
    addCorrectiveAction: 'Adding corrective action',
    editProblems: 'Problems editing',
    reportAccess: 'Reports access',
    targetConfig: 'Access to editing expected targets',
    importer: 'Use data importer to upload activities or items',
    customReportManagement: 'Manage shared custom reports',
    functionsConfig: 'Pre-processing functions configuration',
    hintsConfig: 'Hint rules configuration',
    importTemplatesManagement: 'Manage import templates',
    activityTypesManagement: 'Activity types management',
    plantConfig: 'Plant Configuration',
    configFlow: 'Line structure and connections edit',
    elementsOrder: 'Displaying elements order',
    unitsEdit: 'Units dictionary edit',
    configShifts: 'Shifts timetable and dictionary edit',
    dayStart: 'Day start edit',
    configSignals: 'Signals and properties',
    notificationEdit: 'Notification edit',
    serviceDefinitionManagement: 'Service definition management',
    projectCreate: 'Project create',
    projectAdmin: 'Project administration',
    projectView: 'Display tasks in a project',
    templatesManagement: 'Tasks and tasks group template management',
    questsCreate: 'Quests create',
    questGroupAdmin: 'Group quests management',
    groupQuests: 'Group quests',
    manualDowntime: 'Adding downtimes',
    manualProduction: 'Confirming current production',
    manageDowntimes: 'Downtime management',
    updateSuccessfully: 'Permission update completed successfully.',
    labelling: 'Labelling',
    serializationAndAggregation: 'Serialization and aggregation',
    orders: 'Orders',
    sku: 'SKU',
    labels: 'Labels',
    requests: 'Requests',
    settings: 'Settings',
    planning: 'Planning',
    production: 'Production',
    archive: 'Archive',
    importLog: 'Import log',
    cockpitManagement: 'Cockpit management',
    cockpitView: 'Cockpit view',
    cockpitOperations: 'Cockpit operations',
    cockpitRestrictions: 'Cockpit restrictions',
    ordersManagement: 'Orders management',
    ordersView: 'Orders view',
    ordersLifecycle: 'Orders lifecycle',
    ordersCreate: 'Orders create',
    ordersEdit: 'Orders edit',
    skuManagement: 'SKU management',
    skuView: 'SKU view',
    skuEdit: 'SKU edit',
    skuRestrictions: 'SKU restrictions',
    palletsManagement: 'Pallets management',
    palletsView: 'Pallets view',
    palletsLifecycle: 'Pallets lifecycle',
    goodInQAWebQualitySamples: 'Quality samples report',
    goodInQAWebPallets: 'Pallets report',
    goodInQAMobileQualitySamples: '"QUALITY" module on scanner',
    goodInQAMobilePallets: '"WAREHOUSE" module on scanner',
    bucketServiceWebReworksReport: 'REWORK reports',
    bucketServiceWebMixCockpit: 'MIX Cockpit',
    bucketServiceWebMixArchive: 'MIX Archive',
    bucketServiceMobileReworks: '"REWORK" module on scanner',
    newExperience: 'New experience',
    classicView: 'Classic view',
    searchPermissions: 'Search permissions',
    selectPermissionToPreview: 'Select a permission to configure',
    inheritedTooltip: 'Automatically granted together with a parent permission',
    includedLabel: 'Included',
    grantsLowerLevelPermissionsDisclaimer:
    'Granting this permission will also automatically grant all lower level permissions listed below.',
    showIncludedPermissions: 'Show included permissions',
    includedPermissionsModalTitle: 'Included permissions',
    plantAdminAccessDescription:
      'Full administrative access to the plant, including all its configuration and management permissions.',
    plantElementAccessDescription: 'View plant elements (lines, machines) and browse their data.',
    manageDowntimesDescription: 'Manage downtime reasons and related settings for a plant element.',
    manualDowntimeDescription: 'Manually register a downtime on a plant element.',
    changeDowntimesDescription: 'Edit or reclassify already registered downtimes.',
    orderManagementDescription: 'Manage production orders on a plant element.',
    orderCreateDescription: 'Create new production orders.',
    orderViewAccessDescription: 'View production orders and their details.',
    orderCompleteManualProductionDescription: 'Register manual production on orders that are already completed.',
    orderInprogressEditDescription: 'Edit orders that are currently in progress.',
    orderCompleteEditDescription: 'Edit orders that have already been completed.',
    orderLifecycleDescription: 'Manage the full lifecycle of an order: release, activate and complete it.',
    orderEditDescription: 'Edit order details such as quantity or SKU.',
    manualProductionDescription: 'Register manual production quantities on an order.',
    orderWithdrawDescription: 'Withdraw a released or already activated order.',
    materialManagementDescription: 'Manage master material data for a plant.',
    showSkuListDescription: 'View the list of SKUs.',
    editSkuListDescription: 'Create, edit and organize SKU groups.',
    statesManagementDescription: 'Manage machine states and their related rules.',
    statesEditDescription: 'Edit machine state definitions and rules.',
    addReasonDescription: 'Add new downtime reasons.',
    addCorrectiveActionDescription: 'Add new corrective actions for problems.',
    editProblemsDescription: 'Edit problem definitions and classifications.',
    reportAccessDescription: 'Access reports for the plant or module.',
    configFlowDescription: 'Edit the line structure and connections between elements.',
    elementsOrderDescription: 'Change the display order of plant elements.',
    unitsEditDescription: 'Edit the units dictionary.',
    configShiftsDescription: 'Edit the shifts timetable and dictionary.',
    configSignalsDescription: 'Configure input/output signals for a plant.',
    targetConfigDescription: 'Edit expected performance and energy targets.',
    importerDescription:
      'Upload activities or items into the plant via the data importer, using the configured import templates.',
    customReportManagementDescription: 'Manage custom reports shared across the tenant.',
    functionsConfigDescription: 'Configure pre-processing functions used in data flows.',
    hintsConfigDescription: 'Configure hint rules shown to operators.',
    importTemplatesManagementDescription: 'Manage templates used by the data importer.',
    activityTypesManagementDescription: 'Configure activity types, subtypes and additional fields in the plant.',
    worklogRerunDescription: 'Rerun or replay line data processing for past worklogs.',
    tenantAdminAccessDescription: 'Full administrative access to the tenant and its configuration.',
    usersManagementAccessDescription: 'Manage tenant users, their roles and permissions.',
    notificationEditDescription: 'Edit notification settings for users.',
    plantConfigDescription: 'Configure plant settings and structure.',
    tenantLicenseAccessDescription: "View the tenant's license summary.",
    writeAccessDescription: 'Modify a KeepUp element and its work orders.',
    readAccessDescription: 'View a KeepUp element and its work orders.',
    plantAccessDescription: 'Access a KeepUp plant.',
    projectCreateDescription: 'Create new WorkBoost projects.',
    projectAdminDescription: 'Administer a WorkBoost project and its settings.',
    projectViewDescription: 'View a WorkBoost project and its content.',
    templatesManagementDescription: 'Manage WorkBoost quest and task templates.',
    questsCreateDescription: 'Create new quests within a WorkBoost project.',
    questGroupAdminDescription: 'Administer a WorkBoost quest group.',
    groupQuestsDescription: 'View quests within a WorkBoost quest group.',
    labellingDescription: 'Access LogicPrint5 labelling features.',
    serializationAndAggregationDescription: 'Access serialization and aggregation features in LogicPrint5.',
    ordersDescription: 'Manage orders in LogicPrint5.',
    skuDescription: 'Manage SKUs in LogicPrint5.',
    labelsDescription: 'Manage label templates in LogicPrint5.',
    requestsDescription: 'Manage requests in LogicPrint5.',
    settingsDescription: 'Configure module settings.',
    cockpitManagementDescription: 'Manage the LogicPrint7 cockpit.',
    cockpitViewDescription: 'View the LogicPrint7 cockpit.',
    cockpitOperationsDescription: 'Perform operations from the LogicPrint7 cockpit.',
    cockpitRestrictionsDescription: 'Configure restrictions for the LogicPrint7 cockpit.',
    ordersManagementDescription: 'Manage orders in LogicPrint7.',
    ordersViewDescription: 'View orders in LogicPrint7.',
    ordersLifecycleDescription: 'Manage the lifecycle of LogicPrint7 orders.',
    ordersEditDescription: 'Edit LogicPrint7 orders.',
    ordersCreateDescription: 'Create new LogicPrint7 orders.',
    skuManagementDescription: 'Manage SKUs in LogicPrint7.',
    skuViewDescription: 'View SKUs in LogicPrint7.',
    skuEditDescription: 'Edit SKUs in LogicPrint7.',
    skuRestrictionsDescription: 'Configure SKU restrictions in LogicPrint7.',
    palletsManagementDescription: 'Manage pallets in LogicPrint7.',
    palletsViewDescription: 'View pallets in LogicPrint7.',
    palletsLifecycleDescription: 'Manage the lifecycle of pallets in LogicPrint7.',
    planningDescription: 'Access GoodIn planning features.',
    productionDescription: 'Access GoodIn production features.',
    archiveDescription: 'Access the GoodIn archive.',
    importLogDescription: 'View the GoodIn import log.',
    goodInQAWebQualitySamplesDescription: 'Access the quality samples report in GoodIn QA.',
    goodInQAWebPalletsDescription: 'Access the pallets report in GoodIn QA.',
    goodInQAMobileQualitySamplesDescription: 'Access the "QUALITY" module on the GoodIn QA scanner.',
    goodInQAMobilePalletsDescription: 'Access the "WAREHOUSE" module on the GoodIn QA scanner.',
    bucketServiceWebReworksReportDescription: 'Access rework reports in Bucket Service.',
    bucketServiceWebMixCockpitDescription: 'Access the MIX cockpit in Bucket Service.',
    bucketServiceWebMixArchiveDescription: 'Access the MIX archive in Bucket Service.',
    bucketServiceMobileReworksDescription: 'Access the "REWORK" module on the Bucket Service scanner.',
  },
  registration: {
    register: 'Register',
    companyName: 'Company name',
    companyDescription: 'Company description',
    nextStep: 'Next step',
    companySetUp: 'Set up your company',
    profileSetUp: 'Set up your profile',
    create: 'Create',
    successful: 'Your company and profile have been successfully created',
    getStarted: 'Get started',
    passwordValidation: 'The password should contain at least 6 characters and two numbers',
    products: 'Select products',
    invalidEmail: 'Invalid email',
    regulations: 'I accept the terms and conditions',
    tryAgain: 'Try again',
    addressUrl: 'Address Url',
  },
  keepUp: {
    workBoostIntegration: 'WorkBoost integration',
    useWorkBoost: 'Use WorkBoost',
    project: 'Project',
    type: 'Type',
    initialState: 'Initial state',
  },
  notify: {
    nothing: 'No notifications',
  },
  auditLogs: {
    tenant: 'Tenant',
    version: 'Version',
    timestamp: 'Timestamp',
    type: 'Event type',
    event: 'Event',
    dateRange: 'When',
    aggregateId: 'Aggregate ID',
    userId: 'User ID',
    userName: 'User',
  },
  table: {
    paginationPrevText: 'Prev',
    paginationNextText: 'Next',
  },
  licenses: {
    tenantLicenses: 'Tenant licenses',
    machineLicenses: 'Machine licenses',
    baseAutomated: 'Base Automated Machines',
    advancedAutomated: 'Advanced Signals Extensions',
    entryManual: 'Manual Machines',
    entryDummy: 'Dummy Machines',
    signal: '20 Signals Extensions',
    vision: 'Vision Extensions',
    aggregate: 'Plant aggregate',
    timestamp: 'Machine licenses on',
    year: 'Year',
  },
  import: {
    upload: 'Drop files here to upload',
    notSaved: 'Not saved',
    saved: 'Saved',
    actionRequired: 'Action required',
    checked: 'Verified',
    fillAndAdd: 'Fill and add',
    nothingImported: 'No valid data to import',
    previousImports: 'Previous imports',
    fileIsBeingProcessed: 'File is being processed',
    unableToAssignToRole: 'Failed to assign to the role',
  },
  taxonomies: {
    unableToFetch: 'Classification configuration unavailable',
    taxonomy: 'Taxonomy',
    classification: 'Classification',
    classifications: 'Classifications',
    defaultClassification: 'Default classification',
    defaultTaxonomy: 'Default taxonomy',
    assignTo: 'Assign to',
    pickANode: 'Pick a node',
    nodeDisabledForSelection: 'Disabled for assignment',
    continueToAddNodes: 'Continue to add nodes',
    createNewClassification: 'Create new classification',
    factoryStructure: 'Factory structure',
    problems: 'Problems',
    classificationFor: 'Classification for',
    whereToCloneClassification: 'Where do you want to clone this classification?',
    areYouSureAboutEdit: 'Are you sure you want to edit this section?',
    thisCanProblemsInElements: 'This can cause problems with levels in the connection section.',
    doYouWantToRemoveThisClassification: 'Do you want to remove this classification?',
    enterName: 'Enter name',
    enterDescription: 'Enter description',
    enterCode: 'Enter code',
    level: 'Level',
    levels: 'Levels',
    pickLevel: 'Pick level',
    nodeWarning: 'You must select a level for the node. Check if this node can be below this level',
    editLevels: 'Edit levels',
    addLevel: 'Add level',
    nodes: 'Nodes',
    editNodes: 'Edit nodes',
    addNode: 'Add node',
    addLevelToStartEditing: 'Add level to start editing',
    addNodeToStartEditing: 'Add node to start editing',
    classificationTitle: 'Classification title',
    levelLockedTooltip: 'If level is locked, it\'s not possible to assign any problems or elements '
      + 'to nodes inside that level.',
  },
};
